import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { 
  getAuthToken, 
  isUserAuthenticated,
  getProfileSelector,
  getUserSelector, 
  getFiltersSelector,
  getSelectedFilterSelector,
  getUserLoginHistory,
  getnextResend
  } from '@store/user/user.selectors';
import { 
  userLogin,
  userSendVerification,
  userchangePassword,
  userResetPassword,
  userSignup,
  updateUserProfile,
  updateUserToken,
  userLogout,
  getUser, 
  addFilter,
  getFilters,
  getFilter,
  deleteFilter,
  UpdateUser,
  getUserLoginHistories,
  userSendActivation,
  resendVerification
} from '@store/user/user.actions';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { UserState } from '@models/index';

import { HelperService } from '@services/helper/helper.service';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  backendUrl = environment.backendUrl;

  constructor(
    private router: Router,
    private http: HttpClient,
    private store: Store<{user: UserState}>
  ) {   
    if(localStorage.getItem('authToken')) {
      this.updateUserAuthToken(localStorage.getItem('authToken'));
    }
  }

  public getUserSelector() {
    return this.store.select(getUserSelector);
  }

  public getnextResend() {
    return this.store.select(getnextResend);
  }

  public getProfileSelector() {
    return this.store.select(getProfileSelector);
  }

  public filtersSelector() {
    return this.store.select(getFiltersSelector);
  }

  public filterSelector() {
    return this.store.select(getSelectedFilterSelector);
  }
  public getUserLoginHistoriesSelector() {
    return this.store.select(getUserLoginHistory);
  }

  public dispatchLogin(email : string , password : string) {
    this.store.dispatch(userLogin({ email, password }));
  }

   public dispatchSignup(user: any) {
    this.store.dispatch(userSignup({ user }));
  }

  public dispatchResend(email: string) {
    this.store.dispatch(resendVerification({ email }));
  }

  public dispatchUpdateProfile() {
    this.store.dispatch(updateUserProfile());
  }

  public updateUserAuthToken(authToken: string) {
    this.store.dispatch(updateUserToken({ authToken }));
  }

  public login(email : string , password : string) { 
    const reqBody = { email , password };
    return this.http.post(`${this.backendUrl}/auth/login`, reqBody);
  } 

  public dispatchSendVerification(email : string) {
    this.store.dispatch(userSendVerification({ email }));
  }

  // public sendVerification(email : string) {
  //   const reqBody = { email };
  //   return this.http.post(`${this.backendUrl}/users/user/send-verification`, reqBody);
  // }

  public sendVerification(email : string) {
    const reqBody = { email };
    return this.http.post(`${this.backendUrl}/users/user/password/reset-email`, reqBody);
  }

  public dispatchResetPassword(password, hash, email) {
    this.store.dispatch(userResetPassword({ password, hash , email }));
  }
 
  public dispatchChangePassword(options: any) {
    this.store.dispatch(userchangePassword( { options }));
  }

  public fetchUserLoginHistories(userID: string, page: number, filterOptions: any = {}) {
    this.store.dispatch(getUserLoginHistories({ userID, page, filterOptions }))
  }

  public getUserLoginHistories(userID: string, page: number, filterOptions: any = {}) {
    const queryparams = { ...{ page }, ...filterOptions };
    const queryString = HelperService.generateQueryParams(queryparams);

    return this.http.get(`${this.backendUrl}/users/user/${userID}/login-history?${queryString}`);
  }

  public resetPassword(password : string, hash , email:string) {
    const reqBody = { password, hash, email };
    console.log(reqBody);
    return this.http.post(`${this.backendUrl}/users/user/reset-password/?hash=${hash}`, reqBody);
  }
  
  public changePassword(options: any) {
    return this.http.patch(`${this.backendUrl}/users/user/${options.id}/password`, options);
  }

  public signup(user: any) {
    return this.http.post(`${this.backendUrl}/users/signup`, user);
  }

  public resend(email: string) {
    const reqBody = { "email": email };
    return this.http.post(`${this.backendUrl}/users/resend`, reqBody);
  }

  public updateProfile() {
    return this.http.get(`${this.backendUrl}/auth/profile`);
  }

  public logout() {
    localStorage.removeItem('authToken');
    this.store.dispatch(userLogout());
    this.router.navigateByUrl('/user/login');
  }

  public clearUSerState() {
    this.store.dispatch(userLogout());
  }

  public getUserAuthToken() {
    return this.store.select(getAuthToken);
  }

  public isAuthorized() {
    return this.store.select(isUserAuthenticated);
  }

  public fetchUser(id: string) {
    this.store.dispatch(getUser({ id }))
  }

  public getUser(id: string) {
    return this.http.get(`${this.backendUrl}/users/user/${id}`);
  }

  public addFilter(filter: any) {
    this.store.dispatch(addFilter({ filter }));
  }

  public insertFilter(filter: any) {
    return this.http.post(`${this.backendUrl}/user-filters/filter`, filter);
  }

  public fetchFilters() {
    this.store.dispatch(getFilters());
  }

  public getFilters() {
    return this.http.get(`${this.backendUrl}/user-filters`);
  }

  public fetchFilter(id: string | number) {
    this.store.dispatch(getFilter({ id }));
  }

  public getFilter(id: string | number) {
    return this.http.get(`${this.backendUrl}/user-filters/filter/${id}`);
  }

  public deleteFilter(id) {
    this.store.dispatch(deleteFilter({ id }));
  }

  public removeFilter(id) {
    return this.http.delete(`${this.backendUrl}/user-filters/filter/${id}`);
  }

  updateUser(user) {
    this.store.dispatch(UpdateUser({ user }));
  }

  renewUser(user) {
    return this.http.patch(`${this.backendUrl}/users/user/${user.id}`, user);
  }

  public dispatchSendActivation(code:string, email: string) {
    this.store.dispatch(userSendActivation({ code, email }));
  }

  public sendActivation(code: string, email : string) {
    const reqBody = { code, email };
    return this.http.post(`${this.backendUrl}/users/activation`, reqBody);
  }
}
